import { IGame } from '../types/game';

export function gameStructuralSharing(prev: unknown, next: unknown): unknown {
  const prevGame = prev as IGame | undefined;
  const nextGame = next as IGame;
  if (prevGame && prevGame.seq > nextGame.seq) return prevGame;
  return nextGame;
}
